export enum PublishState {
  DeleteFailed = 'DeleteFailed',
  Deleting = 'Deleting',
  Draft = 'Draft',
  Modified = 'Modified',
  Published = 'Published',
  PublishFailed = 'PublishFailed',
  Publishing = 'Publishing',
}
